import React from "react";
/* eslint-disable react/prop-types */

const TopicsListIcon = ({ size = 30, color = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 32"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {/* Number 1 */}
    <text
      x="1"
      y="6.5"
      fontSize="4.5"
      fontWeight="bold"
      fill={color}
      stroke="none"
    >
      1
    </text>
    {/* Row 1 card */}
    <rect x="7" y="2" width="15" height="9" rx="2" ry="2" />
    <line x1="9.5" y1="5.5" x2="19.5" y2="5.5" />
    <line x1="9.5" y1="8" x2="16" y2="8" />

    {/* Number 2 */}
    <text
      x="1"
      y="15.5"
      fontSize="4.5"
      fontWeight="bold"
      fill={color}
      stroke="none"
    >
      2
    </text>
    {/* Row 2 card */}
    <rect x="7" y="11" width="15" height="9" rx="2" ry="2" />
    <line x1="9.5" y1="14.5" x2="19.5" y2="14.5" />
    <line x1="9.5" y1="17" x2="16" y2="17" />

    {/* Number 3 */}
    <text
      x="1"
      y="24.5"
      fontSize="4.5"
      fontWeight="bold"
      fill={color}
      stroke="none"
    >
      3
    </text>
    {/* Row 3 card */}
    <rect x="7" y="20" width="15" height="9" rx="2" ry="2" />
    <line x1="9.5" y1="23.5" x2="19.5" y2="23.5" />
    <line x1="9.5" y1="26" x2="16" y2="26" />
  </svg>
);

export default TopicsListIcon;
